import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

//Redux
import * as sessionActions from "../../redux/branch/actions";

//Components
import BranchListing from "../../components/BranchList";
import BranchDetailForDealer from "../../components/BranchDetailForDealer";
import BranchUpdate from "../../components/CustomForm";
import TestimonialCreate from "../../components/TestimonialCreate";
import AppliedBranchCreate from "../../components/AppliedBranchCreate";
import AppliedBranchDetail from "../../components/AppliedBranchDetail";

class Branch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRowData: null,
    };
  }

  componentDidMount() {
    // this.props.actions.fetchCountry();
    // this.props.actions.fetchCountryBranch();
    this.handleFetchDealerProfile();
  }

  handleFetchBranch = (data) => {
    this.props.actions.fetchAllBranch(data);
  };

  handleFetchCountry = (data) => {
    this.props.actions.fetchCountry(data);
  };

  handleFetchState = (data) => {
    this.props.actions.fetchState(data);
  };

  handleFetchCity = (data) => {
    this.props.actions.fetchCity(data);
  };

  handleFetchSingleBranch = (data) => {
    this.props.actions.fetchSingleBranch(data);
  };

  handleSelectedRowData = (selectedRowData) => {
    let state = this.state;
    state.selectedRowData = selectedRowData;
    this.setState({ ...state });
  };

  handleFetchBranchCountry = (data) => {
    this.props.actions.fetchCountryBranch(data);
  };

  handleFetchBranchState = (data) => {
    this.props.actions.fetchStateBranch(data);
  };

  handleFetchBranchCity = (data) => {
    this.props.actions.fetchCityBranch(data);
  };

  handleUpdateBranch = (data, reqObj) => {
    this.props.actions.updateBranch(data, reqObj);
  };

  handleBranchDelete = (data) => {
    this.props.actions.deleteBranch(data);
  };

  handleCreateBranchTestimonial = (data) => {
    this.props.actions.createTestimonial(data);
  };

  handleFetchAppliedBranch = (data) => {
    this.props.actions.fetchAppliedBranch(data);
  };

  handleCreateAppliedBranch = (date) => {
    this.props.actions.createAppliedBranch(date);
  };

  handleUpdateAppliedBranch = (date) => {
    this.props.actions.updateAppliedBranch(date);
  };

  handleModerationStatus = (date, reqObj) => {
    this.props.actions.changeModerationStatus(date, reqObj);
  };

  handleFetchDealerProfile = (date) => {
    this.props.actions.fetchDealerProfileForApplyBranch(date);
  };

  handleClearPreviousReducers = () => {
    this.props.actions.clearPreviousReducer();
  };

  handleUpdateButtonClickPlace = (data) => {
    this.props.actions.setUpdateButtonClickPlace(data);
  };

  render() {
    let { page } = this.props.match.params;
    switch (page) {
      case "list":
        return (
          <BranchListing
            handleFetchBranch={this.handleFetchBranch}
            handleFetchCountry={this.handleFetchCountry}
            handleClearPreviousReducers={this.handleClearPreviousReducers}
            handleFetchState={this.handleFetchState}
            handleSelectedRowData={this.handleSelectedRowData}
            handleFetchCity={this.handleFetchCity}
            handleBranchDelete={this.handleBranchDelete}
            countryStatus={this.props.countryStatus}
            countries={this.props.countries}
            stateStatus={this.props.stateStatus}
            states={this.props.states}
            cityStatus={this.props.cityStatus}
            cities={this.props.cities}
            branchStatus={this.props.branchStatus}
            branchCount={this.props.branchCount}
            branches={this.props.branches}
            elements={this.props.elements}
            handleFetchSingleBranch={this.handleFetchSingleBranch}
            handleModerationStatus={this.handleModerationStatus}
            query={this.props.location.search}
            branchUserDataStatus={this.props.branchUserDataStatus}
            branchUserData={this.props.branchUserData}
            branchSingleDataStatus={this.props.branchSingleDataStatus}
            branchData={this.props.branchData}
            moderationStatus={this.props.moderationStatus}
            handleUpdateButtonClickPlace={this.handleUpdateButtonClickPlace}
            accessibleCountries={this.props.accessibleCountries}
            userProfile={this.props.userProfile}
          />
        );
      case "detail":
        return (
          <BranchDetailForDealer
            handleFetchSingleBranch={this.handleFetchSingleBranch}
            handleModerationStatus={this.handleModerationStatus}
            query={this.props.location.search}
            branchUserDataStatus={this.props.branchUserDataStatus}
            branchUserData={this.props.branchUserData}
            branchSingleDataStatus={this.props.branchSingleDataStatus}
            branchData={this.props.branchData}
            elements={this.props.elements}
            moderationStatus={this.props.moderationStatus}
            handleUpdateButtonClickPlace={this.handleUpdateButtonClickPlace}
          />
        );

      case "update-branch":
        return (
          <BranchUpdate
            handleFetchSingleBranch={this.handleFetchSingleBranch}
            handleFetchBranchCountry={this.handleFetchBranchCountry}
            handleFetchBranchState={this.handleFetchBranchState}
            handleFetchBranchCity={this.handleFetchBranchCity}
            handleUpdateBranch={this.handleUpdateBranch}
            page={page}
            handleCreateBranch={this.handleCreateBranch}
            handleSingleDealerFetch={this.handleSingleDealerFetch}
            query={this.props.location.search}
            branchSingleDataStatus={this.props.branchSingleDataStatus}
            branchData={this.props.branchData}
            countriesBranch={this.props.countriesBranch}
            statesBranch={this.props.statesBranch}
            updateBranchStatus={this.props.updateBranchStatus}
            citiesBranch={this.props.citiesBranch}
            elements={this.props.elements}
            updateButtonClickPlace={this.props.updateButtonClickPlace}
          />
        );

      case "create-testimonial":
        return (
          <TestimonialCreate
            query={this.props.location.search}
            creatingTestimonialStatus={this.props.creatingTestimonialStatus}
            handleCreateBranchTestimonial={this.handleCreateBranchTestimonial}
            elements={this.props.elements}
          />
        );

      case "apply-for-branch-create":
        return (
          <AppliedBranchCreate
            handleFetchSingleBranch={this.handleFetchSingleBranch}
            handleFetchAppliedBranch={this.handleFetchAppliedBranch}
            handleFetchBranchCountry={this.handleFetchBranchCountry}
            handleFetchBranchState={this.handleFetchBranchState}
            handleFetchBranchCity={this.handleFetchBranchCity}
            handleUpdateBranch={this.handleUpdateBranch}
            handleFetchDealerProfile={this.handleFetchDealerProfile}
            page={page}
            handleCreateBranch={this.handleCreateBranch}
            handleSingleDealerFetch={this.handleSingleDealerFetch}
            query={this.props.location.search}
            branchSingleDataStatus={this.props.branchSingleDataStatus}
            branchData={this.props.branchData}
            countriesBranch={this.props.countriesBranch}
            statesBranch={this.props.statesBranch}
            updateBranchStatus={this.props.updateBranchStatus}
            citiesBranch={this.props.citiesBranch}
            elements={this.props.elements}
            userProfile={this.props.userProfile}
            handleCreateAppliedBranch={this.handleCreateAppliedBranch}
            createAppliedBranchStatus={this.props.createAppliedBranchStatus}
            dealerProfileStatus={this.props.dealerProfileStatus}
            dealerProfile={this.props.dealerProfile}
          />
        );

      case "apply-for-branch-update":
        return (
          <AppliedBranchCreate
            handleFetchSingleBranch={this.handleFetchSingleBranch}
            handleFetchAppliedBranch={this.handleFetchAppliedBranch}
            handleFetchBranchCountry={this.handleFetchBranchCountry}
            handleFetchBranchState={this.handleFetchBranchState}
            handleFetchBranchCity={this.handleFetchBranchCity}
            handleUpdateBranch={this.handleUpdateBranch}
            handleFetchDealerProfile={this.handleFetchDealerProfile}
            page={page}
            handleCreateBranch={this.handleCreateBranch}
            handleSingleDealerFetch={this.handleSingleDealerFetch}
            query={this.props.location.search}
            branchSingleDataStatus={this.props.branchSingleDataStatus}
            branchData={this.props.branchData}
            countriesBranch={this.props.countriesBranch}
            statesBranch={this.props.statesBranch}
            updateBranchStatus={this.props.updateBranchStatus}
            citiesBranch={this.props.citiesBranch}
            elements={this.props.elements}
            userProfile={this.props.userProfile}
            handleUpdateAppliedBranch={this.handleUpdateAppliedBranch}
            appliedBranchStatus={this.props.appliedBranchStatus}
            appliedBranch={this.props.appliedBranch}
            updateAppliedBranchStatus={this.props.updateAppliedBranchStatus}
            dealerProfileStatus={this.props.dealerProfileStatus}
            dealerProfile={this.props.dealerProfile}
          />
        );

      case "update-profile":
        return (
          <AppliedBranchCreate
            handleFetchSingleBranch={this.handleFetchSingleBranch}
            handleFetchAppliedBranch={this.handleFetchAppliedBranch}
            handleFetchBranchCountry={this.handleFetchBranchCountry}
            handleFetchBranchState={this.handleFetchBranchState}
            handleFetchBranchCity={this.handleFetchBranchCity}
            handleUpdateBranch={this.handleUpdateBranch}
            handleFetchDealerProfile={this.handleFetchDealerProfile}
            page={page}
            handleCreateBranch={this.handleCreateBranch}
            handleSingleDealerFetch={this.handleSingleDealerFetch}
            query={this.props.location.search}
            branchSingleDataStatus={this.props.branchSingleDataStatus}
            branchData={this.props.branchData}
            countriesBranch={this.props.countriesBranch}
            statesBranch={this.props.statesBranch}
            updateBranchStatus={this.props.updateBranchStatus}
            citiesBranch={this.props.citiesBranch}
            elements={this.props.elements}
            userProfile={this.props.userProfile}
            handleUpdateAppliedBranch={this.handleUpdateAppliedBranch}
            appliedBranchStatus={this.props.appliedBranchStatus}
            appliedBranch={this.props.appliedBranch}
            updateAppliedBranchStatus={this.props.updateAppliedBranchStatus}
            dealerProfileStatus={this.props.dealerProfileStatus}
            dealerProfile={this.props.dealerProfile}
          />
        );

      case "apply-for-branch":
        return (
          <AppliedBranchDetail
            handleFetchAppliedBranch={this.handleFetchAppliedBranch}
            page={page}
            elements={this.props.elements}
            appliedBranchStatus={this.props.appliedBranchStatus}
            appliedBranch={this.props.appliedBranch}
          />
        );

      default:
        return null;
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    branchStatus: state.Branch.branchStatus,
    branches: state.Branch.branches,
    branchCount: state.Branch.branchCount,
    countryStatus: state.Branch.countryStatus,
    countries: state.Global.countries,
    stateStatus: state.Branch.stateStatus,
    states: state.Branch.states,
    cityStatus: state.Branch.cityStatus,
    cities: state.Branch.cities,
    updateBranchStatus: state.Branch.updateBranchStatus,
    branchSingleDataStatus: state.Branch.branchSingleDataStatus,
    branchData: state.Branch.branchData,
    branchUserDataStatus: state.Branch.branchUserDataStatus,
    branchUserData: state.Branch.branchUserData,
    countryBranchStatus: state.Branch.countryBranchStatus,
    countriesBranch: state.Global.countries,
    stateBranchStatus: state.Branch.stateBranchStatus,
    statesBranch: state.Branch.statesBranch,
    cityBranchStatus: state.Branch.cityBranchStatus,
    citiesBranch: state.Branch.citiesBranch,
    creatingTestimonialStatus: state.Branch.creatingTestimonialStatus,
    elements: state.Elements.elements,
    userProfile: state.Auth.userProfile,

    appliedBranchStatus: state.Branch.appliedBranchStatus,
    appliedBranch: state.Branch.appliedBranch,
    createAppliedBranchStatus: state.Branch.createAppliedBranchStatus,
    updateAppliedBranchStatus: state.Branch.updateAppliedBranchStatus,
    moderationStatus: state.Branch.moderationStatus,
    dealerProfileStatus: state.Branch.dealerProfileStatus,
    dealerProfile: state.Branch.dealerProfile,
    updateButtonClickPlace: state.Branch.updateButtonClickPlace,
    accessibleCountries: state.Auth.userProfile.accessibleCountries,
    userProfile: state.Auth.currentUserProfile,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Branch));
